import { useMutation } from '@apollo/client';
import { UpdateToolOrderCatalogInput, UpdateToolOrderCatalogResult } from '@bechtel/ht-types';
import { UPDATE_TOOL_ORDER_CATALOG } from '~/gql/tool-order-catalog';

export const useUpdateToolOrderCatalog = (refetchQueries: string[] = ['ToolOrderStats']) => {
  const [updateToolOrderCatalogMutation, { data, loading, error }] = useMutation<
    { updateToolOrderCatalog: UpdateToolOrderCatalogResult },
    { updateToolOrderCatalogInput: UpdateToolOrderCatalogInput }
  >(UPDATE_TOOL_ORDER_CATALOG);

  const updateToolOrderCatalog = (
    input: UpdateToolOrderCatalogInput,
    onCompleted?: (data: UpdateToolOrderCatalogResult) => void,
    onError?: (data: any) => void
  ) => {
    updateToolOrderCatalogMutation({
      variables: {
        updateToolOrderCatalogInput: input,
      },
      onCompleted: (data) => {
        onCompleted && onCompleted(data.updateToolOrderCatalog);
      },
      onError: (data) => {
        onError && onError(data);
      },
      refetchQueries: refetchQueries,
    });
  };

  return { updateToolOrderCatalog, data, loading, error };
};
